/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /Failed to fetch dynamically imported module/;

    // Extract the error message safely
    const errorMessage = error?.message || error?.toString() || '';

    if (chunkFailedMessage.test(errorMessage)) {
      console.warn('Dynamic module fetch failed. Reloading page to fetch the latest version...');
      
      // Reload the page to force the browser to get the new index.html and asset hashes
      window.location.reload();
      return;
    }

    // Log all other standard errors to the console normally
    console.error(error);
  }
}
